import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function pageClassName(variant: 'browse' | 'collection' | 'form' = 'browse') {
  return cn('mx-auto w-full px-4 py-4 md:py-6', variant === 'form' ? 'max-w-2xl' : 'max-w-5xl')
}

export function Page({ children, variant = 'browse', className }: { children: ReactNode; variant?: 'browse' | 'collection' | 'form'; className?: string }) {
  return <div className={cn(pageClassName(variant), className)}>{children}</div>
}

export function PageHeader({ title, subtitle, actions }: { title: string; subtitle?: ReactNode; actions?: ReactNode }) {
  return <header className="mb-4"><div className="flex min-h-11 items-center justify-between gap-3"><h1 className="text-2xl font-semibold tracking-tight text-text">{title}</h1>{actions}</div>{subtitle ? <div className="mt-1 text-sm text-text-muted">{subtitle}</div> : null}</header>
}

export function CollectionHeader({ artwork, kind, title, subtitle, metadata }: { artwork?: ReactNode; kind: string; title: string; subtitle?: ReactNode; metadata?: ReactNode }) {
  return <header className="flex items-center gap-4 sm:items-end sm:gap-5">
    {artwork ? <div className="w-24 shrink-0 sm:w-48">{artwork}</div> : null}
    <div className="min-w-0 flex-1"><p className="text-xs font-medium uppercase tracking-wide text-accent">{kind}</p><h1 className="mt-1 break-words text-2xl font-semibold tracking-tight text-text sm:text-3xl">{title}</h1>{subtitle ? <div className="mt-1 text-sm text-text-muted">{subtitle}</div> : null}{metadata ? <div className="mt-2 text-sm text-text-subtle">{metadata}</div> : null}</div>
  </header>
}
